import {} from './bedOptions.js';
/** Traits a guest carries that the planner must respect. Extend freely. */
export const GUEST_OPTIONS = ['snoring', 'handicap', 'allergies'];
export const GUEST_OPTION_DEFINITIONS = {
    snoring: {
        value: 'snoring',
        label: 'Snores',
        description: 'Keeps light sleepers awake; best grouped with other snorers.',
        forbiddenBedOptions: [],
        clustersWithPeers: true,
        disturbsPeers: true,
    },
    handicap: {
        value: 'handicap',
        label: 'Reduced mobility',
        description: 'Needs a bed that can be reached without climbing.',
        forbiddenBedOptions: ['bunk_top'],
        clustersWithPeers: false,
        disturbsPeers: false,
    },
    allergies: {
        value: 'allergies',
        label: 'Allergies',
        description: 'Recorded for the organiser; no automatic placement rule yet.',
        forbiddenBedOptions: [],
        clustersWithPeers: false,
        disturbsPeers: false,
    },
};
export function isGuestOption(value) {
    return typeof value === 'string' && GUEST_OPTIONS.includes(value);
}
/** Every bed option ruled out by the guest's traits, as a set. */
export function forbiddenBedOptionsFor(options) {
    const forbidden = new Set();
    for (const option of options) {
        for (const bedOption of GUEST_OPTION_DEFINITIONS[option].forbiddenBedOptions) {
            forbidden.add(bedOption);
        }
    }
    return forbidden;
}
//# sourceMappingURL=guestOptions.js.map